{
  "loading": "Loading…",
  "loadError": "Unable to load event information. Please try again later.",
  "directory": {
    "title": "Events",
    "description": "Conferences, courses and workshops. For competitions, see the Competitions page.",
    "empty": "There are no public events right now."
  },
  "type": {
    "conference": "Conference",
    "course": "Course",
    "workshop": "Workshop",
    "seminar": "Seminar",
    "exhibition": "Exhibition",
    "community_event": "Community event"
  },
  "detail": {
    "date": "Date",
    "location": "Location",
    "organizer": "Organizer",
    "registerCta": "Go to official registration",
    "officialCta": "Official website",
    "registrationNotice": "Registration, payment and banquet entitlement are governed by the official TAAI registration system. This page provides supplementary service information only.",
    "shuttleCta": "Free shuttle reservation"
  },
  "shuttle": {
    "title": "Shuttle timetable",
    "direction": {
      "to_venue": "To venue",
      "return": "Return"
    },
    "depart": "Departs",
    "arrive": "Arrives",
    "reserve": "Reserve a seat",
    "waitlistJoin": "Join waitlist",
    "signInToReserve": "Sign in to reserve",
    "reserved": "Done. See My shuttles for details.",
    "availability": {
      "available": "Seats available",
      "few": "Few seats left",
      "full": "Full, waitlist open",
      "unavailable": "Not open yet"
    },
    "myLink": "My shuttles",
    "boarding": "Boarding information",
    "reserveError": "The reservation could not be completed. Please try again later.",
    "reason": {
      "already_booked": "You already have a seat or waitlist spot for that date and direction.",
      "booking_closed": "Reservations for this shuttle have closed.",
      "slot_closed": "This shuttle is not open for reservation.",
      "email_unverified": "Please verify your email first.",
      "idempotency_mismatch": "Please refresh the page and try again.",
      "rider_profile_required": "Please provide your rider contact details first."
    },
    "notice": "The shuttle is free. Reserve with just your email (no account or password), or sign in. One booking per direction per day, for you and up to 3 companions. If a slot is full you can join the waitlist and are promoted automatically in order when someone cancels. Reservations and cancellations close 12 hours before departure.",
    "reservedButton": "Reserved",
    "reservedOk": "Seat reserved",
    "onWaitlist": "On waitlist",
    "waitlistedOk": "Joined waitlist, position #{{position}}",
    "reserving": "Reserving…",
    "lockedByOther": "You already have a seat for another trip in this direction on this date.",
    "manage": "View ticket or cancel",
    "cancel": "Cancel reservation",
    "cancelConfirm": "Cancel this reservation?",
    "cancelFailed": "Cancellation failed. It may have passed the deadline.",
    "cancelling": "Cancelling…",
    "daysLabel": "Service days",
    "signInWhy": "Email-only booking: we send a link, and your seat is held only after you open it. Signing in lets you manage every seat in one place.",
    "summary": "Free · Email only or sign in · Closes 12 hours before departure",
    "rulesTitle": "Booking rules",
    "tzNote": "Taiwan time (UTC+08:00)",
    "lockedDetail": "You already have a seat in this direction at {{time}}.",
    "from": "From",
    "to": "To",
    "code": "Code",
    "codeLegend": "Slot codes work like train numbers: three digits for day, origin and destination. Day: 1 = Nov 20, 2 = Nov 21. Stations: 1 = NTPU, 2 = Banqiao HSR, 3 = venue. For example 113 is day 1, NTPU to venue; 132 is day 1, venue to Banqiao HSR."
  },
  "my": {
    "title": "My shuttles",
    "signIn": "Please sign in",
    "empty": "You have no shuttle reservations.",
    "browse": "View the timetable",
    "confirmed": "Seat confirmed",
    "waitlisted": "Waitlisted (position {{position}})",
    "cancel": "Cancel reservation",
    "cancelConfirm": "Cancel this reservation?",
    "cancelClosed": "The cancellation deadline (12 hours before departure) has passed. Contact the organizer for help.",
    "cancelError": "Cancellation failed. Please try again later.",
    "cutoffNotice": "Cancellation closes 12 hours before departure. You will be emailed when a waitlist spot is confirmed.",
    "qrLabel": "Boarding QR ({{code}})",
    "qrHint": "Show this QR to staff when boarding. Do not share it.",
    "addToCalendar": "Add to calendar",
    "reminderLabel": "Email me a reminder within 24 hours before departure",
    "reminderHint": "Optional. Sent once per confirmed trip to your verified email address, without your boarding QR. You can turn it off here at any time.",
    "reminderError": "The reminder setting could not be saved.",
    "closesLabel": "Cancellation",
    "companionOf": "Companion: {{name}}"
  },
  "staff": {
    "title": "Shuttle check-in",
    "denied": "You do not have staff access for this event.",
    "slot": "Current shuttle",
    "credential": "Boarding credential (scan or paste)",
    "scan": "Check in",
    "error": "Check-in failed. Please retry.",
    "result": {
      "success": "Checked in",
      "duplicate": "Already scanned",
      "wrong_slot": "Wrong shuttle",
      "invalid": "Invalid credential",
      "not_confirmed": "Reservation not confirmed (waitlisted or cancelled)"
    },
    "cameraOn": "Start camera scan",
    "cameraOff": "Stop camera",
    "cameraUnavailable": "Camera scanning is not available on this browser or device. Paste the credential instead.",
    "provisional": "Saved offline (pending sync; the server result is authoritative)",
    "queued": "Offline scans waiting to sync: {{count}}",
    "syncNow": "Sync now",
    "synced": "Synced {{total}} scans; {{conflicts}} were not successful (duplicate, wrong shuttle, etc.).",
    "manual": "Needs manual handling",
    "pendingSync": "Saved on this device, not yet confirmed by the server",
    "sessionCount": "Checked in this session",
    "successLabel": "Boarding confirmed"
  },
  "notices": {
    "title": "Latest notices",
    "severity": {
      "info": "Info",
      "important": "Important",
      "critical": "Critical"
    }
  },
  "services": {
    "title": "Onsite services",
    "meals": "Meals and banquet",
    "help": "Help desk",
    "my": "My shuttles",
    "admin": "Organizer console",
    "volunteer": "Volunteer shifts",
    "presenter": "Posters and speakers",
    "ops": "Operations",
    "mineTitle": "My services",
    "staffTitle": "Staff and participants",
    "checkin": "Shuttle check-in",
    "roster": "Passenger roster"
  },
  "meals": {
    "title": "Meals and banquet response",
    "notice": "Tell us your lunch attendance and dietary needs. Notes are used only for catering and are stored encrypted; check-in staff never see them.",
    "closed": "Meal responses closed (2026-11-16 23:59 UTC+08:00).",
    "attending": "I will attend lunch",
    "dietary": "Dietary category",
    "note": "Additional note (optional, up to 200 characters)",
    "banquet": "Banquet response",
    "banquetNotice": "This response only helps the organizer estimate headcount. It is not banquet entitlement or proof of payment; entitlement is governed by official TAAI registration.",
    "banquetOptions": {
      "yes": "I will attend the banquet",
      "no": "I will not attend the banquet"
    },
    "save": "Save",
    "saved": "Saved.",
    "saveError": "Could not save. Please try again later.",
    "codes": {
      "none": "No special needs",
      "vegetarian": "Vegetarian (egg and dairy)",
      "vegan": "Vegan",
      "halal": "Halal",
      "no_beef": "No beef",
      "no_pork": "No pork",
      "seafood_allergy": "Seafood allergy",
      "nut_allergy": "Nut allergy",
      "other": "Other (explain in note)"
    }
  },
  "help": {
    "title": "Help desk",
    "emergency": "For any emergency affecting safety, call 119 or 110 immediately and tell onsite staff.",
    "contact": "For other questions, submit a case below or see the official website:",
    "signIn": "Sign in to submit a case",
    "category": "Category",
    "categories": {
      "transport": "Transportation",
      "meal": "Meals",
      "registration": "Registration",
      "accessibility": "Accessibility assistance",
      "lost_property": "Lost property",
      "other": "Other"
    },
    "subject": "Subject",
    "body": "Details",
    "urgent": "Urgent",
    "urgentTag": "[Urgent]",
    "submit": "Submit case",
    "sent": "Case submitted. The organizer will follow up.",
    "error": "Could not submit. Please try again later.",
    "mine": "My cases",
    "status": {
      "new": "New",
      "in_progress": "In progress",
      "resolved": "Resolved",
      "closed": "Closed"
    }
  },
  "admin": {
    "title": "Organizer console",
    "checkinLink": "Go to shuttle check-in",
    "provenance": "Source: this platform's database; updated {{time}} (UTC+08:00). Booked, waitlisted and checked-in counts are kept separate.",
    "shuttle": "Shuttle",
    "capacity": "Capacity",
    "confirmed": "Booked",
    "waitlisted": "Waitlisted",
    "checkedIn": "Checked in",
    "meals": "Meals and banquet (counts only)",
    "banquetCounts": "Banquet responses: {{yes}} attending, {{no}} not attending",
    "openTickets": "Open cases: {{count}}",
    "notices": "Notices",
    "severity": "Type",
    "titleZh": "Title (Chinese)",
    "titleEn": "Title (English)",
    "bodyZh": "Body (Chinese)",
    "bodyEn": "Body (English)",
    "publish": "Publish notice",
    "publishError": "Publishing failed.",
    "withdraw": "Withdraw",
    "tickets": "Help desk cases",
    "ticketStatus": "Status",
    "rosterLink": "Passenger roster",
    "tabs": {
      "label": "Console sections",
      "overview": "Overview",
      "notices": "Notices",
      "helpdesk": "Help desk",
      "members": "Members"
    },
    "kpi": {
      "booked": "Seats booked",
      "waitlisted": "Waitlisted",
      "checkedIn": "Checked in",
      "trips": "Trips"
    }
  },
  "volunteer": {
    "title": "My volunteer shifts",
    "empty": "No shifts are assigned to you."
  },
  "presenter": {
    "title": "Poster and speaker services",
    "posters": "My poster and equipment",
    "noPosters": "No poster location is assigned to you.",
    "item": "Equipment",
    "quantity": "Quantity",
    "request": "Submit request",
    "requestError": "The request failed.",
    "items": {
      "power": "Power",
      "table": "Table",
      "monitor": "Monitor",
      "easel": "Easel",
      "other": "Other"
    },
    "status": {
      "requested": "Pending",
      "approved": "Approved",
      "rejected": "Declined"
    },
    "upload": "Slide upload",
    "notSpeaker": "You are not on this event's speaker list. Contact the organizer if this is a mistake.",
    "uploadNotice": "PDF or PPTX only (up to 30 MB, at most 10 files). Files are quarantined for review and only the organizer can download them.",
    "file": "Choose a file",
    "send": "Upload",
    "uploaded": "Uploaded. Waiting for organizer review.",
    "uploadError": "Upload failed. Check the file type and size.",
    "reasons": {
      "file_type_not_allowed": "Only PDF or PPTX files are accepted.",
      "file_too_large": "The file exceeds 30 MB.",
      "file_type_mismatch": "The file content does not match its extension.",
      "too_many_files": "The upload limit has been reached."
    },
    "fileStatus": {
      "pending_review": "Pending review",
      "approved": "Approved",
      "rejected": "Declined"
    }
  },
  "ops": {
    "title": "Operations",
    "back": "Back to organizer console",
    "shifts": "Volunteer shifts",
    "shiftTitle": "Shift name",
    "shiftLocation": "Location",
    "start": "Start",
    "end": "End",
    "volunteerEmails": "Volunteer emails (comma or newline separated)",
    "addShift": "Add shift",
    "error": "The action failed.",
    "posters": "Poster locations",
    "posterFormat": "One per line: location code, title, presenter email",
    "importPosters": "Import official poster allocations",
    "posterError": "Import failed: duplicate location or invalid format. Nothing was written.",
    "equipment": "Equipment requests",
    "approve": "Approve",
    "reject": "Decline",
    "speakers": "Speakers and slides",
    "speakerEmails": "Speaker emails (comma or newline separated)",
    "addSpeakers": "Add speakers",
    "quarantine": "There is no antivirus engine here: files are limited to PDF and PPTX, header-checked and always quarantined. Download and scan locally before approving.",
    "download": "Download",
    "emailPush": "Notice email push",
    "emailNotice": "Preview the audience first; nothing is sent until you confirm. Each recipient receives a notice at most once.",
    "preview": "Preview recipients",
    "previewSummary": "{{count}} recipients ({{done}} already sent).",
    "send": "Confirm and send",
    "sendConfirm": "Send to {{count}} recipients? This cannot be undone.",
    "sendResult": "Sent {{sent}}, skipped {{skipped}}, failed {{failed}}.",
    "tabs": {
      "label": "Operations sections",
      "shifts": "Volunteer shifts",
      "posters": "Posters and equipment",
      "speakers": "Speaker files",
      "email": "Email notices"
    }
  },
  "members": {
    "title": "Event members",
    "help": "Members sign in with a verified email. You can add someone before they register; they show as Pending until they do. Super admins always have owner access.",
    "email": "Email",
    "role": "Role",
    "add": "Add member",
    "remove": "Remove",
    "roleOf": "Role of {{email}}",
    "confirmRemove": "Remove {{email}} from this event?",
    "exists": "This email is already a member.",
    "lastOwner": "The last owner cannot be removed or demoted. Add another owner first.",
    "error": "Could not update members. Please try again.",
    "status": {
      "active": "Active",
      "pending": "Pending registration"
    },
    "roles": {
      "owner": "Owner",
      "manager": "Manager",
      "scanner": "Scanner",
      "viewer": "Viewer"
    },
    "roleHelp": {
      "owner": "everything, including members",
      "manager": "notices, email push, meals export, help desk",
      "scanner": "check-in and passenger list",
      "viewer": "read-only dashboard"
    }
  },
  "rider": {
    "title": "Rider contact details",
    "privacy": "Used only for shuttle changes and on-site emergency contact. On-site check-in staff see your name, organization and job title; only the event owner can view your mobile number (every view is logged). The mobile number is stored encrypted and all of this is deleted 30 days after the event.",
    "realName": "Full real name (required)",
    "organization": "Organization (optional)",
    "jobTitle": "Job title (optional)",
    "mobile": "Mobile number (optional, for urgent changes)",
    "confirm": "I confirm this is my real name, so check-in staff can match me to the passenger list.",
    "submit": "Save and reserve",
    "cancel": "Cancel",
    "error": "Could not save. Check your name (letters, 2-60 characters) and mobile number, then try again."
  },
  "nav": {
    "back": "Back to event"
  },
  "summary": {
    "title": "My itinerary",
    "shuttle": "Shuttles: {{confirmed}} reserved, {{waitlisted}} on waitlist",
    "shuttleNone": "Shuttles: no reservation yet",
    "mealsPending": "Meals and banquet: not answered yet",
    "mealsDone": "Meals and banquet: answered"
  },
  "roster": {
    "title": "Passenger roster",
    "slot": "Shuttle slot",
    "name": "Name",
    "organization": "Organization",
    "jobTitle": "Job title",
    "status": "Status",
    "checkedIn": "Checked in",
    "confirmed": "Confirmed",
    "waitlisted": "Waitlisted",
    "yes": "Yes",
    "no": "No",
    "empty": "No passengers for this slot yet.",
    "loadError": "The roster could not be loaded.",
    "showPhones": "Show emergency phone numbers",
    "phonesNotice": "Phone numbers are for emergencies only. Every time they are shown it is recorded in the audit log.",
    "phonesTitle": "Emergency contacts",
    "phone": "Mobile",
    "noPhone": "Not provided",
    "phonesError": "The phone numbers could not be loaded.",
    "summary": "{{checked}} of {{total}} checked in",
    "search": "Search name or organization",
    "filter": "Status filter",
    "all": "All",
    "notCheckedIn": "Not checked in",
    "checkedInOnly": "Checked in",
    "waitlistedOnly": "Waitlisted",
    "shown": "Showing {{count}}"
  },
  "countdown": {
    "closesIn": "Closes in {{time}}",
    "closed": "Closed",
    "dh": "{{d}}d {{h}}h",
    "hm": "{{h}}h {{m}}m",
    "m": "{{m}}m"
  },
  "nextTrip": {
    "title": "Next shuttle",
    "departsIn": "Departs in {{time}}",
    "departed": "Departing now"
  },
  "quick": {
    "toggle": "Reserve with email only (no account)",
    "formLabel": "Reserve without an account",
    "intro": "No password needed. Enter your name and email; we send a link, and your seat is held only after you open it.",
    "name": "Full real name",
    "email": "Email",
    "confirm": "I confirm this is my real name, used for boarding check.",
    "submit": "Email me the confirmation link",
    "sending": "Sending...",
    "cancel": "Cancel",
    "sent": "Check your inbox at {{email}}. Open the link within 30 minutes to hold your seat. No seat is held yet.",
    "error": "Could not send the request. Check the details and try again.",
    "slotClosed": "This shuttle is no longer open for reservation.",
    "confirmTitle": "Confirming your reservation",
    "confirming": "Confirming...",
    "done": "Your shuttle reservation is confirmed. You are now signed in on this device.",
    "seat": "Seat {{n}}",
    "you": "You",
    "viewMine": "Open My shuttles for QR codes",
    "invalid": "This link is invalid or has expired. Request a new one.",
    "requestAgain": "Request a new link",
    "signInRequired": "This email belongs to an account that must sign in normally.",
    "already_booked": "You already have a seat in this direction on that date, so nothing new was booked.",
    "booking_closed": "Reservations for this shuttle have closed, so nothing was booked.",
    "slot_closed": "This shuttle is not open for reservation, so nothing was booked.",
    "booking_failed": "The reservation could not be completed."
  },
  "companions": {
    "add": "Reserve with companions",
    "hide": "Hide companions",
    "label": "Companion {{n}} full name",
    "addOne": "Add a companion",
    "remove": "Remove companion {{n}}",
    "hint": "Up to 3 companions. Each person gets their own QR code and can be cancelled separately.",
    "submit": "Reserve {{count}} seats",
    "groupLabel": "Companions"
  },
  "shuttlePage": {
    "title": "{{event}}: Free shuttle reservation",
    "intro": "Choose date, direction and time. Free, up to 4 riders per booking.",
    "back": "Back to the event page",
    "language": "Language"
  }
}
